export const getEstimatedReadTime = (richText: any, duration?: boolean) => {
  let articleText: string = "";

  richText.content.forEach((textObj: any) => {
    switch (textObj.type) {
      case "heading":
      case "paragraph":
        textObj.content?.forEach((textContent: any) => {
          articleText += textContent.text;
        });
        break;
    }
  });

  const minutes = Math.ceil(articleText.trim().split(/\s+/).length / 150);

  return duration ? `M(${minutes})` : `${minutes} min`;
};
